(function () {
  'use strict';
  function confirmEmptySlots(options) {
    return new Promise(function(resolve) {
      if (options.signal?.aborted) { resolve('dismiss'); return; }
      var dialog = document.createElement('dialog');
      dialog.className = 'trc-empty-slots-dialog';
      dialog.setAttribute('aria-label', 'Clear empty slots?');
      var title = document.createElement('h2'); title.textContent = 'Clear empty slots?';
      var message = document.createElement('p');
      message.textContent = 'You have ' + options.missing + ' empty slot' + (options.missing === 1 ? '' : 's') + '. Clear them and add your ' + options.filled + ' filled card' + (options.filled === 1 ? '' : 's') + ' per copy to the cart?';
      var price = document.createElement('p'); price.textContent = 'Updated total: ' + options.total;
      var actions = document.createElement('div'); actions.className = 'trc-empty-slots-dialog__actions';
      var edit = document.createElement('button'); edit.type = 'button'; edit.textContent = 'Open editor';
      var confirm = document.createElement('button'); confirm.type = 'button'; confirm.textContent = 'Clear empty slots & add to cart'; confirm.className = 'trc-empty-slots-dialog__confirm';
      actions.append(edit,confirm); dialog.append(title,message,price,actions);
      var settled = false, overlay = null, overlayCleanup = null, returnFocus = document.activeElement;
      function finish(value) {
        if(settled)return; settled=true;options.signal?.removeEventListener('abort',abort);
        if (dialog.open && typeof dialog.close === 'function') { try { dialog.close(); } catch (_) {} }
        dialog.remove(); if (overlay) overlay.remove(); if (overlayCleanup) overlayCleanup();
        if (overlay && returnFocus && returnFocus.isConnected && typeof returnFocus.focus === 'function') { try { returnFocus.focus(); } catch (_) {} }
        resolve(value);
      }
      function abort() { finish('dismiss'); }
      edit.addEventListener('click',function(){finish('edit');});
      confirm.addEventListener('click',function(){finish('confirm');});
      dialog.addEventListener('cancel',function(event){event.preventDefault();finish('dismiss');});
      dialog.addEventListener('click',function(event){
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) finish('dismiss');
      });
      options.signal?.addEventListener('abort',abort,{once:true});
      var modal = false;
      if (typeof dialog.showModal === 'function') {
        document.body.appendChild(dialog);
        try { dialog.showModal(); modal = true; } catch (_) { dialog.remove(); }
      }
      if (!modal) {
        // No modal <dialog> (Safari < 15.4): a fixed overlay with the same
        // choices. Escape and a click outside dismiss; Tab stays inside.
        overlay = document.createElement('div'); overlay.className = 'trc-empty-slots-overlay';
        dialog.setAttribute('role','dialog'); dialog.setAttribute('aria-modal','true'); dialog.setAttribute('open','');
        overlay.appendChild(dialog); document.body.appendChild(overlay);
        overlay.addEventListener('click',function(event){ if (event.target === overlay) finish('dismiss'); });
        // On the document so Escape and Tab work wherever focus is (Safari's
        // Tab skips buttons by default, so focus moves between them here).
        var onKeydown = function(event){
          if (event.key === 'Escape' || event.key === 'Esc') { event.preventDefault(); finish('dismiss'); return; }
          if (event.key !== 'Tab') return;
          event.preventDefault();
          var forward = !event.shiftKey, active = document.activeElement;
          (active === edit ? confirm : active === confirm ? edit : (forward ? edit : confirm)).focus();
        };
        document.addEventListener('keydown',onKeydown,true);
        overlayCleanup = function(){ document.removeEventListener('keydown',onKeydown,true); };
      }
      edit.focus();
    });
  }
  function mount(options) {
    var root = options.root, form = options.form, config = options.config;
    var lifecycle = new AbortController();
    var events = {signal:lifecycle.signal};
    // Safari 14 ignores the signal option, so destroy also removes listeners by hand.
    var added = [];
    function on(target, type, handler) { if (!target) return; target.addEventListener(type, handler, events); added.push([target, type, handler]); }
    if (!root || !config || config.version !== 'eq1') return null;
    var filledButton = options.useFilledButton || form.querySelector('[data-exact-use-filled]');
    var filledCount = 0;
    var finishInput = root.querySelector('[data-exact-finish]');
    var countSelect = root.querySelector('[data-exact-count-select]');
    if (countSelect) {
      var counts = document.createDocumentFragment();
      for (var n = 1; n <= 1000; n++) counts.appendChild(new Option(n + (n === 1 ? ' card' : ' cards'), n + ' Cards'));
      countSelect.appendChild(counts);
    }
    var emptyPriceHints = Array.from(root.querySelectorAll('[data-exact-empty-price]'));
    var copiesInput = form.querySelector('[name="quantity"]');
    var count = 0, imageCount = 100, mode = 'link', source = '', quote = null;
    var money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:config.currency});
    function entry(n) { return config.variants[finishInput.value]?.[n - 1]; }
    function copies() { var n = Number(copiesInput?.value || 1); return Number.isSafeInteger(n) && n > 0 ? n : 1; }
    var priceRows = root.querySelector('[data-exact-pricing-rows]');
    var lastPricingFinish = '';
    function renderPricing() {
      if (!priceRows || lastPricingFinish === finishInput.value) return;
      lastPricingFinish = finishInput.value;
      priceRows.replaceChildren();
      [1,5,10,25,50,75,100,125,150,200,250,300,350,400,450,500,600,700,800,900,1000].forEach(function(n) {
        var row = entry(n); if (!row) return;
        var tr = document.createElement('tr');
        [n.toLocaleString(),money.format(row[1]/100),(row[1]%n ? '≈ ' : '') + money.format(row[1]/n/100)].forEach(function(value) {
          var td = document.createElement('td'); td.textContent=value; tr.appendChild(td);
        });
        priceRows.appendChild(tr);
      });
      root.querySelector('[data-exact-pricing-caption]').textContent = finishInput.value + ' pricing';
    }
    function render() {
      if (filledButton) filledButton.hidden = mode !== 'images' || filledCount < 1 || filledCount >= imageCount;
      var row = entry(count), total = row ? row[1] * copies() : 0;
      var ready = config.ready !== false && !!row && count > 0;
      root.querySelector('[data-exact-line]')?.toggleAttribute('hidden', !ready);
      var prompt = root.querySelector('[data-exact-prompt]');
      if (prompt) {prompt.textContent = ready ? 'How pricing works' : 'Add cards to see prices.';prompt.classList.toggle('trc-exact-warning',!ready);}
      emptyPriceHints.forEach(function(hint){hint.hidden=ready;});
      var cardLabel = root.querySelector('[data-exact-card-label]');
      if (cardLabel) cardLabel.textContent = count * copies() === 1 ? 'card' : 'cards';
      root.querySelectorAll('[data-exact-finish-choice]').forEach(function(input){input.checked = input.dataset.exactFinishChoice === finishInput.value;});
      var finishLabel = root.querySelector('[data-exact-finish-label]');
      if (finishLabel) finishLabel.textContent = finishInput.value;
      root.querySelectorAll('[data-exact-finish-price]').forEach(function(label){
        var price = config.variants[label.dataset.exactFinishPrice]?.[count - 1];
        label.textContent = ready && price ? money.format(price[1] / 100) : '';
      });
      renderPricing();
      if (countSelect) countSelect.value = ready ? count + ' Cards' : '';
      root.querySelector('[data-exact-total-cards]').textContent = ready ? (count * copies()).toLocaleString() : '';
      root.querySelector('[data-exact-total-price]').textContent = ready ? money.format(total / 100) : '';
      root.querySelector('[data-exact-unit-price]').textContent = ready ? (row[1] % count ? '≈ ' : '') + money.format(row[1] / count / 100) : '';
      root.querySelector('[data-exact-status]').textContent = ready ? (quote ? 'Validated' : 'Estimated') + ' · ' + count + (count === 1 ? ' card per copy · ' : ' cards per copy · ') + copies() + (copies() === 1 ? ' copy' : ' copies') : (config.ready === false ? 'Pricing is being updated. Please reload shortly.' : 'Upload your list to calculate your cards and price.');
      root.querySelector('[data-exact-property]').value = ready ? String(count) : '';
      root.querySelector('[data-exact-property]').disabled = !ready;
    }
    function select(n) {
      var row = entry(n); if (config.ready === false || !row) return false;
      var field = form.querySelector('[name="id"]');
      field.value = String(row[0]);
      // The owner synchronizes its validation identity atomically before any observer runs.
      options.onVariant?.(String(row[0]));
      return true;
    }
    function setCount(n, nextSource) {
      count = Number.isSafeInteger(n) && n >= 1 && n <= 1000 ? n : 0;
      source = nextSource || ''; quote = null;
      if (count) select(count); render();
    }
    function setMode(next) { mode = next; quote = null; count = mode === 'images' ? imageCount : 0; select(count || 1000); render(); }
    function adopt(next) {
      if (!next || next.pricingVersion !== config.version || next.currency !== config.currency) throw new Error('Pricing changed. Reload the product and validate again.');
      var row = entry(next.count);
      if (!row || String(row[0]) !== String(next.variantId) || row[1] !== next.priceCents) throw new Error('Pricing changed. Reload the product and validate again.');
      count = next.count; quote = next; select(count); render();
    }
    root.querySelectorAll('[data-exact-finish-choice]').forEach(function(button){
      on(button,'change',function(){if (!button.checked) return;finishInput.value=button.dataset.exactFinishChoice;finishInput.dispatchEvent(new Event('change',{bubbles:true}));});
    });
    on(finishInput,'change',function(){quote=null; select(count || 1000);render();options.onChange?.();});
    on(copiesInput,'input',render); on(copiesInput,'change',render);
    on(filledButton,'click',function(){
      if (mode !== 'images' || filledButton.hidden) return;
      var n=options.onUseFilled?.();if(!n)return; imageCount=n;setCount(n,'images');options.onChange?.();
    });
    select(1000); render();
    return {destroy:function(){lifecycle.abort();added.splice(0).forEach(function(entry){entry[0].removeEventListener(entry[1],entry[2]);});},setCount:setCount,setMode:setMode,adopt:adopt,render:render,
      confirmEmptySlots:function(){
        var row=entry(filledCount);
        if(mode!=='images'||filledCount<1||filledCount>=imageCount||!row)return Promise.resolve('dismiss');
        return confirmEmptySlots({missing:imageCount-filledCount,filled:filledCount,total:money.format(row[1]*copies()/100),signal:lifecycle.signal});
      },
      invalidate:function(){quote=null;render();},
      restoreCount:function(n){imageCount=n;if(mode==='images')setCount(n,'images');else render();},
      imageCount:function(){return imageCount;}, count:function(){return count;},
      valid:function(){return config.ready !== false && !!entry(count) && count>0;},
      finish:function(){return finishInput.value;},
      showFilled:function(n){filledCount=Number(n)||0;render();}
    };
  }
  window.TRCExactQuantity = {mount:mount,confirmEmptySlots:confirmEmptySlots};
  document.dispatchEvent(new CustomEvent('trc-exact-quantity-ready'));
}());
